import { render, staticRenderFns } from "./NewAdminForm.vue?vue&type=template&id=287b89a8"
import script from "./NewAdminForm.vue?vue&type=script&lang=js"
export * from "./NewAdminForm.vue?vue&type=script&lang=js"
import style0 from "./NewAdminForm.vue?vue&type=style&index=0&id=287b89a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports